

import { Component, OnInit, ChangeDetectorRef, AfterViewInit, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { TabledataService } from '../_services/tabledata.service';
import { GlobalsService } from '../_services/globals.service';
import { Mapapi } from '../ol-map/mapapi';
import { ElementRef, ViewChild } from '@angular/core';
import { EventsService } from '../_services/events.service';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoginService } from '../login/login.service';
import { ConfirmationService } from 'primeng/api';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { GraphviewService } from '../graphview/graphview.service';
import { ReportsService } from 'app/reports/reports.service';
import { IRemotePowerDetails } from 'app/interfaces/IRemotePowerDetails';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { PickListModule } from 'primeng/picklist';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { MessageService } from 'primeng/api';
import { Tabs } from 'primeng/tabs';
import { NgZone } from '@angular/core';
import { take } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpEventType} from '@angular/common/http';
import { ProgressBarModule } from 'primeng/progressbar';
import { KeycloakService } from '../login/keycloak.service';
import { TreeNode } from 'primeng/api';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    styleUrls: ['./table.component.css'],
    standalone: false
})
export class TableComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
    displayCsvBtns = null;
    tabindex: number | null = null;
    selectedTabItem: any = null;
    tablerows: number = 10;
    first: number = 0;
    tables: any[] = [];
    tableShowData: any;
    tmptables: any[] = [];
    editablename: any;
    editabledatakeys: any[] = [];
    showCrudDialog: boolean = false;
    showFilesDialog: boolean = false;
    showRemotePowerDetailsTableDialog: boolean = false;
    remotePowerDetailsTable: any;
    downloadFilesList: any[] = [];
    downloadFilesListFiltered: any = {};
    downloadFilesListFilteredKeys: any[] = [];
    noFiles: boolean = false;
    uploadurl: string | undefined;
    _documents_folder: any;
    docTypes: any = [];
    curenttableforedit: any;
    loaded_ob_mid: any;
    canUpload: boolean;
    canDownload: boolean;

    canopenFileDialog: boolean;
    tmpTableHeight: number = 0;
    showDetailDialog: boolean = false;
    showRemotePowerDialog = false;
    tableRowDetail: any = {};
    remotePowerDetails: any;
    remotePowerPayload: IRemotePowerDetails | undefined
    // areaID: number;
    form: FormGroup | undefined;
    showRemotePowerDetailsDialog: boolean = false;
    progressbarvisible: boolean = false;
    progressbartxt: any;
    progressbarvalue: number = 0;
    progressbarinterval: any = null;
    essub: { unsubscribe: () => void; } | undefined;

    loadingTableId: number | null = null;

    selectedDocType: string = '';

    selectedDocTypeId: number | null = null;

    docTree: TreeNode[] = [];
    selectedDocNode: TreeNode | null = null;
    pendingUploadNode: TreeNode | null = null;

    showNewFolderDialog = false;
    newFolderName = '';
    createUnderSelected = true; // true => subfolder, false => root folder

    showRenameFolderDialog = false;
    renameFolderName = '';
    renameFolderNode: TreeNode | null = null;
    selectedDocNodeKey: string | null = null;

    currentHouseName: string = '';

    changeLogs: Record<string, any> = {};

    fieldNotes: Record<string, string> = {};
    showFieldNoteDialog = false;
    currentNoteField: string | null = null;
    currentNoteText = '';

    @ViewChild(Tabs) tabs!: Tabs;
    @ViewChild('tabList', { read: ElementRef }) tabList!: ElementRef<HTMLElement>;
    @ViewChild('nativeFileInput') nativeFileInput!: ElementRef<HTMLInputElement>;

    private destroy$ = new Subject<void>();
    private pendingSelectNodeId: string | null = null;

    fullChangeLogs: Record<string, any[]> = {};
    expandedHistory: Record<string, boolean> = {};
    hasUnsavedChanges = false;
    detailDialogReady = false;

    columnDescriptions: Record<string, Record<string, any>> = {};
    columnDescriptionsLoading: Record<string, boolean> = {};

    private readonly DOC_FOLDER_DESC_SCHEMA = 'podatki_elek';
    private readonly DOC_FOLDER_DESC_TABLE = 'documents_folders';

    folderDescriptions: Record<string, string> = {};
    folderDescriptionsLoaded = false;

    draggedDocNode: TreeNode | null = null;

    columnMeta: Record<string, Record<string, any>> = {};

    columnLabels: Record<string, string> = {};

    private readonly STEVILSKA_POLJA = new Set<string>([
        'eol_raba_ee_tc_kwh',
        'ove_leto_izvedbe'
    ]);

    constructor(private tableService: TabledataService, private es: EventsService, private gs: GlobalsService,
        private ls: LoginService, private mapapi: Mapapi, private cs: ConfirmationService, private fb: FormBuilder,
        private gvs: GraphviewService, private rs: ReportsService, private messageService: MessageService,
        private zone: NgZone, private cdr: ChangeDetectorRef, private http: HttpClient, private sanitizer: DomSanitizer) {
        
        this.canUpload = this.ls.isAuthorisedRole("upload") || this.ls.isAuthorisedRole("admin");
        this.canDownload = this.ls.isAuthorisedRole("download") || this.ls.isAuthorisedRole("admin");
        this.canopenFileDialog = this.canDownload || (this.ls.isAuthorisedRole("upload") || this.ls.isAuthorisedRole("admin"));
        
        this.es.getOnRemoteBtnEmit()
        .pipe(takeUntil(this.destroy$))
        .subscribe(res => {
            console.warn("SUBSCRIBED REMOTE BTN", res)
            this.openRemotePowerAnalyse({data: res.attributes});
        })

    }

    uploadHandler(event: any) {
        const file: File | undefined = event?.files?.[0];
        if (!file) return;

        if (!this._documents_folder) {
            this.messageService.add({
                key: 'table',
                severity: 'warn',
                summary: 'Napaka',
                detail: 'Manjka ID mape dokumentov.'
            });
            return;
        }

        if (!this.loaded_ob_mid) {
            this.messageService.add({
                key: 'table',
                severity: 'warn',
                summary: 'Napaka',
                detail: 'Manjka ob_mid.'
            });
            return;
        }

        const fd = new FormData();
        fd.append('file', file, file.name);
        fd.append('id', String(this._documents_folder));
        fd.append('docTypeId', String(this.selectedDocTypeId));
        fd.append('docdir', String(this.selectedDocType ?? ''));
        fd.append('ob_mid', String(this.loaded_ob_mid));

        const uploadUrl = `${this.gs.getRestUrl()}/api/documents/upload`;

        this.uploading = true;
        this.uploadProgress = 0;

        this.http.post(uploadUrl, fd, {
            reportProgress: true,
            observe: 'events'
        }).subscribe({
            next: (ev: any) => {
                if (ev.type === HttpEventType.UploadProgress && ev.total) {
                    this.uploadProgress = Math.round((ev.loaded / ev.total) * 100);
                }

                if (ev.type === HttpEventType.Response) {
                    this.uploading = false;
                    this.uploadProgress = 100;
                    this.showUploadProgress = false;

                    this.messageService.add({
                        key: 'table',
                        severity: 'success',
                        summary: 'Uspešno',
                        detail: 'Datoteka je naložena.'
                    });

                    if (this.pendingUploadNode?.key) {
                        this.pendingSelectNodeId = this.pendingUploadNode.key;
                    }

                    this.getFileList(this.pendingUploadNode?.key ?? this.selectedDocNodeKey);
                    this.selectedUploadFile = null;

                    if (this.nativeFileInput?.nativeElement) {
                        this.nativeFileInput.nativeElement.value = '';
                    }

                    this.pendingUploadNode = null;

                    setTimeout(() => {
                        this.uploadProgress = 0;
                    }, 500);
                }
            },
            error: (err) => {
                this.uploading = false;
                this.uploadProgress = 0;
                this.showUploadProgress = false;

                const msg = err?.error?.error || err?.message || 'Napaka pri nalaganju';
                this.messageService.add({
                    key: 'table',
                    severity: 'error',
                    summary: 'Napaka',
                    detail: msg
                });

                this.selectedUploadFile = null;

                if (this.nativeFileInput?.nativeElement) {
                    this.nativeFileInput.nativeElement.value = '';
                }

                this.pendingUploadNode = null;
            }
        });
    }

    private async checkSelectedFileDuplicate(file: File) {
        if (!this._documents_folder) return;

        const sha = await this.sha256Hex(file);

        if (!sha) {
            this.messageService.add({
                key: 'table',
                severity: 'warn',
                summary: 'Opozorilo',
                detail: 'SHA-256 preverjanje ni na voljo v tem okolju. Nadaljujem brez preverjanja duplikatov.'
            });
            return;
        }

        if (this.selectedUploadFile !== file) return;

        const id = encodeURIComponent(String(this._documents_folder));
        const url = `${this.gs.getRestUrl()}/api/documents/check?id=${id}&sha256=${sha}`;

        this.tableService.getData(url, true).subscribe({
            next: (res: any) => {
                if (this.selectedUploadFile !== file) return;

                if (res?.exists) {
                    const where = (res.matches ?? [])
                        .map((m: any) => m.docDir)
                        .filter(Boolean)
                        .join(', ');

                    this.messageService.add({
                        key: 'table',
                        severity: 'warn',
                        summary: 'Duplikat',
                        detail: `Ta datoteka že obstaja. Lokacija: ${where || '(neznano)'}`
                    });

                    this.selectedUploadFile = null;
                }
            },
            error: (err) => {
                console.error('Duplicate check failed', err);
                // do not block upload if duplicate check fails
            }
        });
    }

    triggerUploadForFolder(node: TreeNode) {
        if (!node || node.data?.type !== 'folder' || this.uploading) return;

        this.selectedDocNode = node;
        this.selectedDocNodeKey = node.key ?? null;
        this.pendingUploadNode = node;
        this.pendingSelectNodeId = node.key ?? null;

        node.expanded = true;

        this.updateSelectedDocTypeFromTree();
        this.onBeforeUploadFile(null);

        if (!this.selectedDocTypeId) {
            this.showMsgs('warn', 'Izberi veljavno mapo.');
            return;
        }

        this.nativeFileInput?.nativeElement?.click();
    }

    private expandPathToNode(nodes: TreeNode[], key: string): boolean {
        for (const node of nodes || []) {
            if (node.key === key) {
                return true;
            }

            if (node.children?.length) {
                const foundInChildren = this.expandPathToNode(node.children, key);
                if (foundInChildren) {
                    node.expanded = true;
                    return true;
                }
            }
        }

        return false;
    }

    async onNativeFileSelected(event: Event) {
        if (this.uploading) {
            this.messageService.add({
                key: 'table',
                severity: 'warn',
                summary: 'Opozorilo',
                detail: 'Počakajte, da se trenutna datoteka naloži.'
            });
            return;
        }

        const input = event.target as HTMLInputElement;
        const file = input?.files?.[0] ?? null;

        this.selectedUploadFile = file;
        this.uploading = false;
        this.uploadProgress = 0;

        if (!file) return;

        await this.checkSelectedFileDuplicate(file);

        if (!this.selectedUploadFile) return;

        this.startManualUpload();
    }

    private normDir(s: any): string {
        return String(s ?? '')
            .replace(/\\/g, '/')          // backslashes -> slashes
            .replace(/^\/+|\/+$/g, '')    // trim leading/trailing slashes
            .replace(/\/{2,}/g, '/')      // collapse // -> /
            .trim();
    }

    private buildDocumentTree(folderNodes: any[], files: any[]): TreeNode[] {
        const tree = this.mapToTreeNodes(folderNodes);

        const folderMap = new Map<number, TreeNode>();

        const walk = (nodes: TreeNode[]) => {
            for (const n of nodes || []) {
                if (n.data?.type === 'folder' && n.data?.id != null) {
                    folderMap.set(Number(n.data.id), n);
                }
                walk(n.children || []);
            }
        };
        walk(tree);

        for (const f of files || []) {
            const id = encodeURIComponent(String(this._documents_folder));
            const docId = encodeURIComponent(String(f.docId));

            const docTypeId = f.docTypeId == null ? null : Number(f.docTypeId);
            const dir = this.normDir(f.dir);

            const fileNode: TreeNode = {
                key: `file-${f.docId}`,
                label: f.originalName,
                leaf: true,
                data: {
                    type: 'file',
                    docId: f.docId,
                    docTypeId,
                    dir,
                    originalName: f.originalName,
                    url: `${this.gs.getRestUrl()}/api/documents/file?id=${id}&docId=${docId}`,
                    urlPreview: `${this.gs.getRestUrl()}/api/documents/preview?id=${id}&docId=${docId}`,
                    urlDelete: `${this.gs.getRestUrl()}/api/documents/delete?id=${id}&docId=${docId}`
                }
            };

            const parent = docTypeId == null ? null : folderMap.get(docTypeId);

            if (parent) {
                if (!parent.children) parent.children = [];
                parent.children.push(fileNode);
            } else {
                tree.push(fileNode);
            }
        }

        this.sortTreeDocumentsFirst(tree);
        this.applyFolderDescriptionsToTree(tree);
        return tree;
    }

    showUploadProgress = false;

    startManualUpload() {
        if (!this.selectedUploadFile || this.uploading) return;

        this.showUploadProgress = this.selectedUploadFile.size >= 1000000;

        this.onBeforeUploadFile(null);

        if (!this.uploadurl) {
            this.messageService.add({
                key: 'table',
                severity: 'warn',
                summary: 'Napaka',
                detail: 'Upload URL ni nastavljen.'
            });
            return;
        }

        this.uploading = true;
        this.uploadProgress = 0;

        this.messageService.add({
            key: 'table',
            severity: 'info',
            summary: 'Obvestilo',
            detail: 'Datoteka se nalaga...'
        });

        this.uploadHandler({
            files: [this.selectedUploadFile]
        });
    }

    cancelSelectedFile(input?: HTMLInputElement) {
        this.selectedUploadFile = null;
        this.uploading = false;
        this.uploadProgress = 0;
        this.showUploadProgress = false;

        if (input) {
            input.value = '';
        }
    }

    onDocDragStart(event: DragEvent, node: TreeNode): void {
        if (node.data?.type !== 'file') {
            event.preventDefault();
            return;
        }

        event.stopPropagation();
        this.draggedDocNode = node;

        if (event.dataTransfer) {
            event.dataTransfer.setData('text/plain', String(node.data?.docId ?? ''));
            event.dataTransfer.effectAllowed = 'move';
        }
    }

    dragOverFolderKey: string | null = null;

    onDocDragEnter(event: DragEvent, node: TreeNode): void {
    if (node.data?.type !== 'folder') return;

    event.preventDefault();
    event.stopPropagation();

    this.dragOverFolderKey = node.key ?? null;

    if (event.dataTransfer) {
        event.dataTransfer.dropEffect = 'move';
    }
    }

    onDocDragOver(event: DragEvent, node: TreeNode): void {
    if (node.data?.type !== 'folder') return;

    event.preventDefault();
    event.stopPropagation();

    this.dragOverFolderKey = node.key ?? null;

    if (event.dataTransfer) {
        event.dataTransfer.dropEffect = 'move';
    }
    }

    onDocDragLeave(event: DragEvent, node: TreeNode): void {
    const current = event.currentTarget as HTMLElement;
    const related = event.relatedTarget as Node | null;

    if (related && current.contains(related)) return;

    if (this.dragOverFolderKey === node.key) {
        this.dragOverFolderKey = null;
    }
    }

    onDocDrop(event: DragEvent, targetNode: TreeNode): void {
        event.preventDefault();
        event.stopPropagation();

        console.log('DROP TARGET:', targetNode);
        console.log('DRAGGED NODE:', this.draggedDocNode);
        console.log('FILES:', event.dataTransfer?.files?.length);

        if (targetNode.data?.type !== 'folder') {
            console.warn('DROP target is not folder');
            this.draggedDocNode = null;
            return;
        }

        const files = event.dataTransfer?.files;

        if (files && files.length > 0) {
            this.uploadDroppedFile(files[0], targetNode);
            this.draggedDocNode = null;
            return;
        }

        if (this.draggedDocNode?.data?.type === 'file') {
            this.moveDocumentToFolder(this.draggedDocNode, targetNode);
        } else {
            console.warn('No dragged file node');
        }

        this.draggedDocNode = null;
        this.dragOverFolderKey = null;
    }

    onDocDragEnd(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();

        setTimeout(() => {
            this.draggedDocNode = null;
        }, 0);

        this.dragOverFolderKey = null;
    }
    
    private sortTreeDocumentsFirst(nodes: TreeNode[]): void {
        const cmp = (a: TreeNode, b: TreeNode) => {
            const aIsFile = a.data?.type === 'file';
            const bIsFile = b.data?.type === 'file';

            if (aIsFile !== bIsFile) return aIsFile ? -1 : 1;

            if (!aIsFile && !bIsFile) {
                const sa = Number(a.data?.sortNo ?? 9999);
                const sb = Number(b.data?.sortNo ?? 9999);
                if (sa !== sb) return sa - sb;
            }

            return String(a.label ?? '').localeCompare(String(b.label ?? ''), 'sl');
        };

        nodes?.sort(cmp);

        for (const node of nodes || []) {
            if (node.children?.length) this.sortTreeDocumentsFirst(node.children);
        }
    }

    private getExpandedFolderKeys(nodes: TreeNode[]): Set<string> {
        const keys = new Set<string>();

        const walk = (items: TreeNode[]) => {
            for (const n of items || []) {
                if (n.data?.type === 'folder' && n.expanded && n.key) {
                    keys.add(n.key);
                }

                if (n.children?.length) {
                    walk(n.children);
                }
            }
        };

        walk(nodes);
        return keys;
    }

    private restoreExpandedFolderKeys(nodes: TreeNode[], keys: Set<string>): void {
        const walk = (items: TreeNode[]) => {
            for (const n of items || []) {
                if (n.data?.type === 'folder' && n.key && keys.has(n.key)) {
                    n.expanded = true;
                }

                if (n.children?.length) {
                    walk(n.children);
                }
            }
        };

        walk(nodes);
    }

    private async uploadDroppedFile(file: File, folderNode: TreeNode): Promise<void> {
        if (!this.canUpload) {
            this.showMsgs('warn', 'Nimate pravice za nalaganje dokumentov.');
            return;
        }

        this.selectedDocNode = folderNode;
        this.selectedDocNodeKey = folderNode.key ?? null;
        this.pendingUploadNode = folderNode;
        this.pendingSelectNodeId = folderNode.key ?? null;

        folderNode.expanded = true;

        this.updateSelectedDocTypeFromTree();

        if (!this.selectedDocTypeId) {
            this.showMsgs('warn', 'Izberi veljavno mapo.');
            return;
        }

        this.selectedUploadFile = file;

        await this.checkSelectedFileDuplicate(file);

        if (!this.selectedUploadFile) return;

        this.startManualUpload();
    }

    private moveDocumentToFolder(fileNode: TreeNode, targetFolderNode: TreeNode): void {
        if (!this.canUpload) {
            this.showMsgs('warn', 'Nimate pravice za premikanje dokumentov.');
            return;
        }

        const docId = fileNode.data?.docId;
        const targetDocTypeId = targetFolderNode.data?.id;

        if (docId == null || targetDocTypeId == null || this._documents_folder == null) {
            this.showMsgs('warn', 'Manjkajo podatki za premik dokumenta.');
            return;
        }

        const url = `${this.gs.getRestUrl()}/api/documents/move`;

        const body = {
            id: this._documents_folder,
            docId: docId,
            targetDocTypeId: targetDocTypeId,
            obMid: this.loaded_ob_mid
        };

        console.log('MOVE BODY:', body);

        this.http.post(url, body).subscribe({
            next: () => {
                this.messageService.add({
                    key: 'table',
                    severity: 'success',
                    summary: 'Uspešno',
                    detail: 'Dokument je premaknjen.'
                });

                const targetKey = targetFolderNode.key ?? null;
                this.pendingSelectNodeId = targetKey;
                this.getFileList(targetKey);
            },
            error: (err) => {
                console.error('MOVE ERROR FULL:', err);
                console.error('MOVE ERROR BODY:', err?.error);

                this.messageService.add({
                    key: 'table',
                    severity: 'error',
                    summary: 'Napaka',
                    detail: err?.error?.error || err?.error?.msg || err?.message || 'Napaka pri premiku dokumenta.'
                });
            }
        });
    }

    private getTabHeaderScroller(): HTMLElement | null {
        const tablist = this.tabList?.nativeElement;
        if (!tablist) return null;

        // Find the closest element in the tabs header area that is actually scrollable
        const candidates: HTMLElement[] = [
            tablist,
            ...(Array.from(tablist.parentElement?.querySelectorAll<HTMLElement>('*') ?? []))
        ];

        return candidates.find(el => el.scrollWidth > el.clientWidth) ?? null;
    }

    private rafId: number | null = null;

    private focusAndScrollActiveTab() {
        // cancel any pending scroll job
        if (this.rafId !== null) {
            cancelAnimationFrame(this.rafId);
            this.rafId = null;
        }

        this.zone.onStable.pipe(take(1)).subscribe(() => {
            this.rafId = requestAnimationFrame(() => {
            const scroller = this.getTabHeaderScroller();
            const tablist = this.tabList?.nativeElement;
            if (!scroller || !tablist) return;

            const activeTab =
                (tablist.querySelector('.p-tab.p-tab-active') as HTMLElement | null) ||
                (tablist.querySelector('[role="tab"][aria-selected="true"]') as HTMLElement | null);

            if (!activeTab) return;

            const sRect = scroller.getBoundingClientRect();
            const tRect = activeTab.getBoundingClientRect();

            const leftOverflow = tRect.left - sRect.left;
            const rightOverflow = tRect.right - sRect.right;

            if (leftOverflow < 0) scroller.scrollLeft += leftOverflow;
            else if (rightOverflow > 0) scroller.scrollLeft += rightOverflow;

            // if you still need this for PrimeNG arrow enable/disable:
            queueMicrotask(() => window.dispatchEvent(new Event('resize')));
            });
        });
    }

    trackByTableId = (_: number, t: any) => t?.id ?? _;

    onTabsValueChange(tabId: number) {
        this.tabindex = tabId;
        this.selectedTabItem = null;
    }

    private refreshTabsScroll() {
        queueMicrotask(() => {
            requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                window.dispatchEvent(new Event('resize'));
            });
            });
        });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();

        this.essub?.unsubscribe();

        if (this.previewObjectUrl) {
            URL.revokeObjectURL(this.previewObjectUrl);
            this.previewObjectUrl = null;
        }
    }
    
    ngOnChanges(changes: SimpleChanges): void {
        
    }

    public isMol(): boolean {
        return Number(this.loaded_ob_mid) === 11027849;
    }

    private getJavneStavbeLayerIdForCurrentObcina(): number {
        return this.isMol()
            ? Number(this.gs.getJavneStavbeMolLayerId())
            : Number(this.gs.getJavneStavbeLayerId());
    }

    public additionalBtnClick(item: any, table: any): void {
        console.log("item", item);
        console.log("table", table);
        
        if (item._report_name !== undefined) {
            let reportid;
            let rname = item['_report_name'];
            let reportname = rname.split("#")[0];
            let reportidfield = rname.split("#")[1];
            let reportlabel = rname.split("#")[2];
            let reportparam = reportidfield.replace('_', '');
            console.warn("REPORT ID..", rname, reportidfield, reportparam)
            if (item[reportidfield] !== undefined) {
                reportid = item[reportidfield];
            }
            
            this.runReport(reportparam, reportid, reportname);

        }


        if (Number(table.id) === this.getJavneStavbeLayerIdForCurrentObcina()) {
            this._documents_folder = item._documents_folder;
            this.currentHouseName = item?.naziv || '';

            // IMPORTANT: ensure upload URL is correct BEFORE user uploads
            this.updateSelectedDocTypeFromTree();
            this.onBeforeUploadFile(null);

            this.loadFolderDescriptions();
            this.getFileList(this.pendingUploadNode?.key ?? this.selectedDocNodeKey);
        }

    }


    private runReport(param: string, val: string, ime: string) {


        this.messageService.add({ key: 'table', severity: 'info', summary: 'Obvestilo', detail: 'Poročilo v izdelavi, prosimo počakajte ....' });
        this.rs.exportFile(ime, "pdf", "userLocale=de&reportLocale=de&" + param + "=" + val + "&showreports=" + ime)
            .subscribe(d => {
                this.rs.downloadFile(d, ime + ".pdf", "pdf");
                this.messageService.add({ key: 'table', severity: 'info', summary: 'Obvestilo', detail: 'Poročilo izdelano ... ' });
            }, e => {
                this.messageService.add({ key: 'table', severity: 'error', summary: 'Obvestilo', detail: e?.error?.error || e?.error?.message || e?.message || 'Prišlo je do napake.' });
            }, () => { this.messageService.clear(); });
    }

    public getSelectedItem() {
        const t = this.tmptables.find(x => x.id === this.tabindex);
        return t?.selectedItem;
    }

    public onPageChange(event: any, table: any) {
        table.rows = event.rows;
        table.first = event.first;
    }

    private proggresBar(on: boolean, txt: any) {

        if (this.progressbarinterval != null)
            clearInterval(this.progressbarinterval);

        this.progressbarvalue = 0;
        this.progressbarvisible = on;
        this.progressbartxt = txt;

        this.progressbarinterval = setInterval(() => {
            this.progressbarvalue = this.progressbarvalue + 1;
            if (this.progressbarvalue === 100) {
                clearInterval(this.progressbarinterval);
            }
        }, 50);
    }

    private santinizeToLocale(data: any, start?: any, end?: any) {
        if (!Array.isArray(data)) return data;

        for (const r of data) {
            if (!r || typeof r !== 'object') continue;
            if (r.__loc) continue;   // že formatirano, ne podvajaj

            Object.keys(r).forEach((f: string) => {
                if (f === 'geometry' || f === 'the_geom') return;
                r[f] = this.toLocaleStr(r[f], f);
            });

            Object.defineProperty(r, '__loc', { value: true, enumerable: false });
        }

        return data;
    }

    private toLocaleStr(v: any, attrname: any): any {
        if (v === null || v === undefined || v === '') return v;

        const ime = String(attrname ?? '');

        // polja, ki niso merske številke
        if (ime === 'leto' || ime.includes('leto_') || ime.includes('leto ')
            || ime.includes('poštna')
            || ime === '_gid' || ime === '_id' || ime === '_na_mid' || ime === '_ob_mid'
            || ime === '_id_stavba' || ime === '_eid_stavba' || ime === '_documents_folder') {
            return v;
        }

        if (typeof v === 'number') {
            return v.toLocaleString('sl');
        }

        if (typeof v !== 'string') return v;

        const s = v.trim();

        // že slovenski zapis (1.234,56 ali 185) -> pusti pri miru
        if (/^-?\d{1,3}(\.\d{3})*(,\d+)?$/.test(s)) return s;

        // angleški zapis (1234.56, 57.6, 1,234.56) -> pretvori
        if (/^-?\d+(\.\d+)?$/.test(s) || /^-?\d{1,3}(,\d{3})+(\.\d+)?$/.test(s)) {
            const n = Number(s.replace(/,/g, ''));
            if (!isNaN(n)) return n.toLocaleString('sl');
        }

        // sestavljene vrednosti (2x 70,7 ; 185 + 22,4) pusti nedotaknjene
        return s;
    }

    public disableWheel(event: any) {
        event.preventDefault();
    }

    openFieldNoteDialog(field: string) {
        this.currentNoteField = field;
        this.currentNoteText = this.fieldNotes[field] || '';
        this.showFieldNoteDialog = true;
    }

    saveFieldNote() {
        if (this.currentNoteField) {
            this.fieldNotes[this.currentNoteField] = this.currentNoteText || '';
        }

        this.showFieldNoteDialog = false;
        this.currentNoteField = null;
        this.currentNoteText = '';
    }

    getFieldNote(field: string): string {
        return this.fieldNotes[field] || '';
    }

    toggleHistory(field: string) {
        this.expandedHistory[field] = !this.expandedHistory[field];
    }

    getFullHistory(field: string): any[] {
        const all = this.fullChangeLogs[field] || [];

        if (!all.length) return [];

        return all.slice(1);
    }

    public detailRow(item: any, table: any): void {
        const userdataTable = this.isMol()
            ? "javna_stavba_mol_userdata"
            : "javna_stavba_userdata";

        this.tableService.getData(
            this.gs.getRestUrl() +
            "/api/tabletypes/fieldtypes?tablename=" + userdataTable +
            "&tablenameschema=podatki_elek"
        ).subscribe((d: any) => {

            var cItem = Object.assign({}, item);

            table.node.data.edittable = this.extractEditableAttributes(d, cItem);
            this.showDetailDialog = true;

            setTimeout(() => {
                this.detailDialogReady = true;
            });

            let detailKeys = Object.keys(cItem);

            // skrij vse od sekcije OSTALO naprej
            const ostaloIndex = detailKeys.findIndex(k =>
                k.toLowerCase() === "_ostalo" || k.toLowerCase() === "ostalo"
            );

            if (ostaloIndex >= 0) {
                detailKeys = detailKeys.slice(0, ostaloIndex);
            }

            this.tableRowDetail.keys = detailKeys.filter(k => {
                return k !== "layerID"
                    && k !== "ftID"
                    && k !== "the_geom"
                    && k !== "geom";
            });
            this.tableRowDetail.attributes = cItem;
            this.tableRowDetail.table = table;

            this.changeLogs = {};
            this.fieldNotes = {};
            this.fullChangeLogs = {};
            this.expandedHistory = {};
            this.currentNoteField = null;
            this.currentNoteText = '';
            this.showFieldNoteDialog = false;
            this.hasUnsavedChanges = false;
            this.detailDialogReady = false;

            if (this.isMol()) {
                const id = cItem["_id_stavba"];

                if (id) {
                    const url = `${this.gs.getRestUrl()}/api/javnastavbamoluserdata/${encodeURIComponent(id)}/logs/latest`;

                    const historyUrl =
                        `${this.gs.getRestUrl()}/api/javnastavbamoluserdata/${encodeURIComponent(id)}/logs`;

                    this.tableService.getData(historyUrl, true).subscribe((res: any) => {
                        this.fullChangeLogs = {};

                        const logs = Array.isArray(res)
                            ? res
                            : Array.isArray(res?.molLogDTO)
                                ? res.molLogDTO
                                : res?.molLogDTO
                                    ? [res.molLogDTO]
                                    : [];

                        logs.forEach((l: any) => {
                            const fieldName = l.fieldName || l.field_name;

                            if (!fieldName) return;

                            if (!this.fullChangeLogs[fieldName]) {
                                this.fullChangeLogs[fieldName] = [];
                            }

                            this.fullChangeLogs[fieldName].push({
                                oldValue: l.oldValue || l.old_value,
                                newValue: l.newValue || l.new_value,
                                changedBy: l.changedBy || l.changed_by,
                                changedAt: l.changedAt || l.changed_at,
                                opomba: l.opomba || l.note || null
                            });
                        });

                        console.log("FULL HISTORY RAW", res);
                        console.log("FULL HISTORY PARSED", this.fullChangeLogs);
                    });

                    this.tableService.getData(url, true).subscribe((res: any) => {
                        this.changeLogs = {};

                        const logs = Array.isArray(res)
                            ? res
                            : Array.isArray(res?.molLogDTO)
                                ? res.molLogDTO
                                : res?.molLogDTO
                                    ? [res.molLogDTO]
                                    : [];   

                        logs.forEach((l: any) => {
                            const fieldName = l.fieldName;

                            this.changeLogs[fieldName] = {
                                oldValue: l.oldValue,
                                newValue: l.newValue,
                                changedBy: l.changedBy,
                                changedAt: l.changedAt,
                                opomba: l.opomba || l.note || null
                            };
                        });

                        console.log("CHANGE LOGS RAW", res);
                        console.log("CHANGE LOGS PARSED", this.changeLogs);
                    });
                }
            }
        });
    }

    public getChangeLog(field: string): any {
        return this.changeLogs?.[field] ?? null;
    }

    public replaceAll(what: string) {
        const direct = this.columnLabels[what];
        if (direct) return direct;

        if (what.startsWith('_')) {
            const stripped = this.columnLabels[what.substring(1)];
            if (stripped) return stripped;
        }

        let fldName = what.replace(new RegExp('prezracevalni', 'g'), 'prezračevalni');
        what = what.replace(new RegExp('_kWh', 'g'), ' [kWh]');
        what = what.replace(new RegExp('prezracevalni', 'g'), 'prezračevalni');
        what = what.replace(new RegExp('dosezeni', 'g'), 'doseženi');
        what = what.replace(new RegExp('elektricna', 'g'), 'električna');
        what = what.replace(new RegExp('zveplo', 'g'), 'žveplo');
        what = what.replace(new RegExp('stevilo', 'g'), 'število');
        what = what.replace(new RegExp('delez', 'g'), 'delež');
        what = what.replace(new RegExp('moc', 'g'), 'moč');
        what = what.replace(new RegExp('_kW', 'g'), ' [kW]');
        what = what.replace(new RegExp('kWh_', 'g'), '[kWh] ');
        what = what.replace(new RegExp('_Sm3', 'g'), ' [Sm3]');
        what = what.replace(new RegExp('_GJ', 'g'), ' [GJ]');

        if (what.substring((what.length - 2), what.length) === "_t")
            what = what.substring(0, what.length - 2) + " [t]";

        what = what.replace(new RegExp('_', 'g'), ' ');
        return what;
    }

    public get canEditObcinskeStavbeMol(): boolean {
        return this.ls.isAuthorisedRole('edit-obcinske-stavbe-mol')
            || this.ls.isAuthorisedRole('admin');
    }

    public canEditTable(table: any): boolean {
        if (table?.node?.data?.edittable === undefined) return false;

        return this.isMol()
            ? this.canEditObcinskeStavbeMol
            : !!table?.hasPermissionAdmin;
    }

    private extractEditableAttributes(editable: any[], attributes: any): any {
        const valid: { [key: string]: any } = {};
        const ob: { [key: string]: any } = {};
        editable.map(e => {
            if (
                e["column_name"] === "id_stavba" ||
                e["column_name"] === "id_stavbe"
            ) {
                return;
            }

            var cType = String(e["data_type"] ?? "").toLowerCase().trim();
            Object.keys(attributes).map(a => {
                console.warn("extractEditableAttributes", a, e)
                if (e["column_name"] === a || a.substr(1, a.length - 1) === e["column_name"]) {


                    ob[e["column_name"]] = attributes[a];
                    valid[a] = [attributes[a], function (c: any) {
                        var value = c.value;

                        var isIntType = cType.startsWith("int")
                            || cType.startsWith("smallint")
                            || cType.startsWith("bigint")
                            || cType.startsWith("serial");

                        var isDecType = cType.startsWith("numeric")
                            || cType.startsWith("decimal")
                            || cType.startsWith("double")
                            || cType.startsWith("real")
                            || cType.startsWith("float")
                            || cType.startsWith("money");

                        if (isIntType) {
                            return TableComponent.isInt(value)
                                ? null
                                : { error: "Vrednost je lahko le celo število: " + c.value };
                        }

                        if (isDecType) {
                            return TableComponent.isDouble(value)
                                ? null
                                : { error: "Vrednost je lahko le število: " + c.value };
                        }

                        return null;
                    }]
                }

            })

        });
        this.form = this.fb.group(valid);
        return ob;
    }

    public isEditableField(efields: any[], item: any): any {

        var r = Object.keys(efields).filter(f => { return f === item || f === item.substr(1, item.length - 1) });
        return r.length > 0;
    }

    markAsDirty(): void {
        if (!this.detailDialogReady) return;

        this.hasUnsavedChanges = true;
    }

    onConfirmCancel(cd: any): void {
        try {
            if (typeof cd?.reject === 'function') {
                cd.reject();
            }
        } catch (e) {
            console.error('confirm reject error', e);
        }

        try {
            if (typeof cd?.hide === 'function') {
                cd.hide();
            }
        } catch (e) {
            console.error('confirm hide error', e);
        }

        this.cdr.detectChanges();
    }

    closeDetailDialog(): void {
        if (!this.hasUnsavedChanges) {
            this.showDetailDialog = false;
            this.detailDialogReady = false;
            return;
        }

        this.cs.confirm({
            header: 'Ali želite shraniti spremembe?',
            accept: () => {
                this.doSaveWFST(true);
            },
            reject: () => {
                this.showDetailDialog = false;
                this.hasUnsavedChanges = false;
                this.detailDialogReady = false;
            }
        });
    }

    public saveWFST() {
        this.cs.confirm({
            header: 'Ali želite shraniti podatke?',
            accept: () => {
                this.doSaveWFST(false);
            }
        });
    }

    private doSaveWFST(closeAfterSave: boolean): void {

        if (this.form && this.form.invalid) {
            this.form.markAllAsTouched();
            this.messageService.add({
                key: 'table',
                severity: 'error',
                summary: 'Napaka',
                detail: 'Vnos ni veljaven. Preverite označena polja.'
            });
            return;
        }

        if (this.form) {
            Object.keys(this.form.controls).forEach(k => {
                this.tableRowDetail.attributes[k] = this.form!.controls[k].value;
            });
        }

        const saveData = this.normalizeSaveDataWFST(
            this.tableRowDetail.table.node.data.edittable,
            this.tableRowDetail.attributes
        );

        if (this.isMol()) {
            saveData._opomba = JSON.stringify(this.fieldNotes || {});
        }

        const saveUrl = this.isMol()
            ? this.gs.getRestUrl() + '/api/javnastavbamoluserdata/save'
            : this.gs.getRestUrl() + '/api/javnastavbauserdata/save';

        this.tableService.addNewData(saveUrl, JSON.stringify(saveData)).subscribe({
            next: () => {
                const node = this.tableRowDetail.table.node;

                this.hasUnsavedChanges = false;

                if (closeAfterSave) {
                    this.showDetailDialog = false;
                }

                if (node?.data) {
                    delete node.data.tabledataloaded;

                    if (node.data.additionalData) {
                        delete node.data.additionalData.tabledataloaded;
                    }
                }

                // takoj posodobi izbrano vrstico v tabeli, brez čakanja na ponovno nalaganje
                const t = this.tables.find(x => x.id === this.tableRowDetail?.table?.id);
                const pk = this.tableRowDetail?.attributes?.['_id_stavba'];

                if (t?.data && pk) {
                    const vrstica = t.data.find((r: any) => r['_id_stavba'] === pk);

                    if (vrstica) {
                        Object.keys(saveData).forEach(k => {
                            if (k === 'id_stavba' || k === '_opomba') return;

                            const kljuc = (k in vrstica) ? k
                                        : ('_' + k in vrstica) ? '_' + k
                                        : null;

                            if (kljuc) {
                                vrstica[kljuc] = this.toLocaleStr(saveData[k], kljuc);
                            }
                        });
                    }
                }

                this.tableService.setRequestTableData(node);
                this.cdr.detectChanges();

                this.messageService.add({
                    key: 'table',
                    severity: 'info',
                    summary: 'Obvestilo',
                    detail: 'Podatki so bili uspešno shranjeni!'
                });
            },
            error: (err) => {
                this.messageService.add({
                    key: 'table',
                    severity: 'error',
                    summary: 'Napaka',
                    detail: err?.error?.error || err?.error?.message || err?.message
                            || 'Shranjevanje ni uspelo.'
                });
            }
        });
    }

    filesTabValue: string | null = null;


    private getFileList(keepSelectedFolderKey?: string | null): void {
        const expandedKeys = this.getExpandedFolderKeys(this.docTree);

        if (keepSelectedFolderKey) {
            expandedKeys.add(keepSelectedFolderKey);
        }

        this.downloadFilesList = [];
        this.noFiles = false;

        this.tableService
            .getData(this.gs.getRestUrl() + "/api/documents/list?id=" + this._documents_folder, true)
            .subscribe((d: any) => {
                const list = Array.isArray(d) ? d : [];

                this.downloadFilesList = list;

                this.pendingSelectNodeId = keepSelectedFolderKey ?? this.selectedDocNodeKey ?? null;

                this.loadDocTypesForObMid(this.loaded_ob_mid, expandedKeys);

                this.showFilesDialog = true;
            }, e => console.log(e));
    }


    public downloadFile(dat: any) {
        this.tableService.getFile(dat.url, true, dat.originalName);
    }

    public deleteFile(url: any) {
        const selectedKey = this.selectedDocNodeKey;

        this.cs.confirm({
            header: 'Ali želite izbrisati datoteko ?',
            accept: () => {
                this.tableService.deleteFile(url, true).subscribe(() => {
                    this.getFileList(selectedKey);
                });
            }
        });
    }

    private static parseNum(raw: any): { ok: boolean; value: number | null } {
        if (raw === null || raw === undefined) return { ok: true, value: null };

        const s = String(raw).trim();
        if (s === '') return { ok: true, value: null };

        // "1.234.567,89" -> "1234567.89" ; "1234.56" ostane "1234.56"
        const norm = s.includes(',')
            ? s.replace(/\s/g, '').replace(/\./g, '').replace(',', '.')
            : s.replace(/\s/g, '');

        if (!/^-?\d+(\.\d+)?$/.test(norm)) return { ok: false, value: null };

        return { ok: true, value: Number(norm) };
    }

    private static isDouble(n: any): boolean {
        return TableComponent.parseNum(n).ok;
    }

    private static isInt(n: any): boolean {
        const p = TableComponent.parseNum(n);
        return p.ok && (p.value === null || Number.isInteger(p.value));
    }

    toDbFormat(data: any) {
        const p = TableComponent.parseNum(data);
        return p.ok ? p.value : data;
    }

    getHeaderColspan(table: any): number {
        let cols = (table?.fields || []).filter((c: any) => !c.hidden).length;

        if (table?.node?.data?.tablebutton !== undefined && this.canopenFileDialog) cols++;
        if (this.canEditTable(table)) cols++;
        if (table?.iSadditionalData && table?.hasPermissionAdmin) cols++;

        return Math.max(cols, 1);
    }

    private createForm(table: any, cb: any) {
        var tbnup = table.node.data.additionalData.url.split("?")[1].split("&")[0];
        var tablename = tbnup.split('=')[1];
        var tblschema = tablename.split(".")[0];
        var tblnm = tablename.split(".")[1];
        this.editablename = tblnm;
        this.tableService.getData(this.gs.getRestUrl() + "/api/tabletypes/fieldtypes?tablename=" + tblnm + "&tablenameschema=" + tblschema).subscribe((d: any) => {
            const valid: { [key: string]: any } = {};
            var showf: any[] = [];
            var self = this;

            d.map((i: any) => {
                //console.log(i)
                var col = i.column_name;
                var typ = i.data_type;
                if (col.substring(0, 1) !== "_") {

                    valid[col] = [this.curenttableforedit.selectedItem[col], function (c: any) {
                        c.datatype = typ;
                        c.column = col;
                        var value = c.value;

                        if (typ === "integer") {

                            var isInt = TableComponent.isInt(value);
                            //console.log(n)
                            if (isInt) {
                                // console.log("ok");
                                return null;
                            }
                            else {
                                // console.log("err:"+c.value + "tip:"+typ);
                                return { error: "Vrednost je lahko le celo število: " + c.value };
                            }
                        }
                        else if (typ === "double precision") {
                            var isDouble = TableComponent.isDouble(value);

                            if (isDouble) {
                                return null;
                            }
                            else {
                                return { error: "Vrednost je lahko le decimalno število: " + c.value };
                            }
                        }
                        return null;
                    }];
                    showf.push(col);

                }
            });
            this.form = this.fb.group(valid);
            this.editabledatakeys = showf;

            cb(valid);
        });
    }

    checkInputFieldValue(evt: any, c: any) {
        if (c.datatype === "double precision" && evt.keyCode !== 8 && c.value !== undefined) // only 2 dec digits
        {
            var n = Number(c.value);

            if (c.value !== undefined && c.value !== null && c.value.split(".") !== undefined && c.value.split(".")[1] !== undefined && c.value.split(".")[1].length > 1) {
                evt.preventDefault();
                evt.stopPropagation();
                if (!isNaN(n)) {
                    var dec = n.toFixed(2);
                    c.setValue(dec);
                }
            }
        }
    }

    public exportCsv(url: any, node: any): void {
        url = url.replace(/ /g, '+');
        url = encodeURIComponent(url);
        this.tableService.getCsv(this.gs.getRestUrl() + "/api/geoserver/toCsv?url=" + url, false, node.label + ".csv");
    }

    public getJavneStavbeMolLayerId(): number {
        return Number(this.gs.getJavneStavbeMolLayerId());
    }

    public exportEnergetskeIzkaznice(): void {
        const url = `${this.gs.getRestUrl()}/api/reports/energetske-izkaznice`
                + `?ob_mid=${encodeURIComponent(String(this.loaded_ob_mid))}`;

        this.tableService.getFile(url, true, 'energetske_izkaznice.xlsx');
    }

    public showEiExport(table: any): boolean {
        return this.isMol()
            && Number(table?.id) === Number(this.gs.getJavneStavbeMolLayerId());
    }


    public add(table: any): void {

        this.curenttableforedit = table;
        this.curenttableforedit.selectedItem = {};
        //this.editablename = table.node.data.additionalData.title; 
        this.createForm(table, (r: any) => {
            this.showCrudDialog = true;
        });

    }

    public edit(item: any, table: any): void {
        var cItem = Object.assign({}, item);
        this.curenttableforedit = table;
        this.curenttableforedit.selectedItem = cItem;
        //this.editablename = table.node.data.additionalData.title;
        this.createForm(table, (r: any) => {
            this.showCrudDialog = true;
        });
    }

    public delete(): void {

        this.showCrudDialog = false;
        this.save(true);
    }

    private vSlovenskiZapis(v: any): string {
        const s = String(v).trim();
        // samo čisto število v angleškem zapisu; sestavljenih vrednosti ne diramo
        return /^-?\d+\.\d+$/.test(s) ? s.replace('.', ',') : s;
    }

    private normalizeSaveData(saveData: any): any {
        for (let d in saveData)//change keys for jpa
        {

            saveData[d] = this.toDbFormat(saveData[d]);

            if (d === "_ob_mid") {
                saveData.obMid = saveData[d];
                delete saveData[d];
            }
            else if (d === "_gid") {
                saveData.gid = saveData[d];
                delete saveData[d];
            }
        }
        //console.log(saveData);
        return saveData;
    }


    private normalizeSaveDataWFST(editable: any, attributes: any): any {

        var pk = attributes["_id_stavba"] || attributes["_stavba_global_id"];

        var ob: Record<string, any> = {};

        if (this.isMol()) {
            ob["id_stavba"] = pk;
        } else {
            ob["id_stavbe"] = pk;
        }

        Object.keys(editable).map(e => {

            Object.keys(attributes).map(a => {

                if (e === a || a.substr(1, a.length - 1) === e) {

                    const value = attributes[a];

                    if (value === null || value === undefined) {
                        ob[e] = null;
                    } else if (typeof value === 'string' && value.trim().length === 0) {
                        ob[e] = null;
                    } else if (this.STEVILSKA_POLJA.has(e)) {
                        ob[e] = this.toDbFormat(value);
                    } else {
                        // tekstovna polja: vejica ostane vejica
                        ob[e] = this.vSlovenskiZapis(value);
                    }

                }
            })
        });

        console.log("WFST SAVE DATA", ob);

        return ob;
    }

    public save(del: boolean = false): void {
        let saveData = JSON.parse(JSON.stringify(this.curenttableforedit.selectedItem));//clone
        saveData = this.normalizeSaveData(saveData);

        if (this.editablename === "poraba_plin") {
            this.editablename = "porabaplin"
        }
        else if (this.editablename === "poraba_elektricna_energija") {
            this.editablename = "porabaelektricnaenergija";
        }
        else if (this.editablename === "poraba_industrija") {
            this.editablename = "porabaindustrija";
        }
        else if (this.editablename === "poraba_javna_razsvetljava") {
            this.editablename = "porabajavnarazsvetljava";
        }
        else {
            this.editablename = "porabadaljinskoogrevanje";
        }

        if (saveData.gid === undefined) {
            saveData.obMid = this.loaded_ob_mid;
            this.cs.confirm({
                header: 'Ali želite dodati podatke ?',
                accept: () => {
                    this.tableService.addNewData(this.gs.getRestUrl() + "/api/" + this.editablename, JSON.stringify(saveData)).subscribe((json: any) => {
                        this.tableService.setRequestTableData(this.curenttableforedit.node);
                        this.messageService.add({ key: 'table', severity: 'info', summary: 'Obvestilo', detail: 'Podatki so bili uspešno dodani !' });

                    }, err => { console.log("NAPAKA 1:" + err); this.messageService.add({ key: 'table', severity: 'error', summary: 'Obvestilo', detail: err?.error?.error || err?.error?.message || err?.message || 'Prišlo je do napake.' }); }, () => { console.log("done save new") });
                }
            });
        }
        else {
            this.cs.confirm({
                header: 'Ali želite shraniti popravljene podatke ?',
                accept: () => {
                    this.tableService.editData(this.gs.getRestUrl() + "/api/" + this.editablename + "/" + saveData.gid, JSON.stringify(saveData)).subscribe(json => {

                        this.tableService.setRequestTableData(this.curenttableforedit.node);
                        this.messageService.add({ key: 'table', severity: 'info', summary: 'Obvestilo', detail: 'Podatki so bili uspešno popravljeni !' });

                    }, err => { console.log(err); this.messageService.add({ key: 'table', severity: 'error', summary: 'Obvestilo', detail: err?.error?.error || err?.error?.message || err?.message || 'Prišlo je do napake.' }); }, () => { console.log("done save edit") });
                }
            });
        }

        if (del) {
            this.cs.confirm({
                header: 'Ali  želite brisati podatke?',
                accept: () => {
                    //console.log("save delete");
                    this.tableService.deleteData(this.gs.getRestUrl() + "/api/" + this.editablename + "/" + saveData.gid).subscribe(json => {
                        this.tableService.setRequestTableData(this.curenttableforedit.node);
                        this.messageService.add({ key: 'table', severity: 'info', summary: 'Obvestilo', detail: 'Podatki so bili uspešno izbrisani !' });
                    }, err => { console.log(err); this.messageService.add({ key: 'table', severity: 'error', summary: 'Obvestilo', detail: err?.error?.error || err?.error?.message || err?.message || 'Prišlo je do napake.' }); }, () => { console.log("done delete") });
                }
            });

        }
        //console.log(this.curenttableforedit);
        this.showCrudDialog = false;
    }

    public changeTableTab(event: any): void {
        this.tabindex = event?.value ?? null;
        this.selectedTabItem = null;
    }

    closeTableTab(tabId: number) {
        const idx = this.tmptables.findIndex(t => t.id === tabId);
        if (idx < 0) return;

        // update canonical table state
        const t = this.tmptables[idx];
        t.node.data.tableOn = false;
        t.visible = false;

        // also update in tables[] (same object usually, but safe)
        const canon = this.tables.find(x => x.id === tabId);
        if (canon) {
            canon.node.data.tableOn = false;
            canon.visible = false;
        }

        // remove ONLY this tab
        this.tmptables.splice(idx, 1);

        // keep active tab sane
        if (this.tmptables.length === 0) {
            this.tabindex = null;
        } else if (this.tabindex === tabId) {
            // prefer previous tab, else next
            const nextIdx = Math.max(0, idx - 1);
            this.tabindex = this.tmptables[nextIdx].id;
        }

        this.tableService.setCountVisibleTable(this.tmptables.length);
        this.refreshTabsScroll();

        this.cdr.detectChanges();
        this.focusAndScrollActiveTab();
    }

    public setTableScrollBar(data: any): void {

        //data.scrollable = this.tablerows <= data.data.length;
        data.scrollable = true;
        //console.log("scroll:"+data.scrollable + " label :"+data.label + "tr:"+this.tablerows + " ds :");
    }


    ngAfterViewInit() {
        this.refreshTabsScroll();
    }

    private isInTableArray(d: any): number {

        var c = 0;
        for (let t of this.tables) {

            if (t.label === d.label) {
                return c;
            }
            c++;
        }

        return -1;
    }

    private isInTableTmpArray(d: any): number {
        var c = 0;
        for (let t of this.tmptables) {
            if (t.label == d.label) {
                return c;
            }
            c++;
        }
        return -1;
    }

    private isLastVisibleInTableArray(): number {
        var c = -1;

        for (let t of this.tmptables) {
            c = this.isInTableTmpArray(t)


        }
        return c;
    }

    private closeAllTables() {


        for (let t of this.tables) {
            this.tableService.setShowTable(t.id, false, t.label, t.node);
            t.node.data.tableOn = false;
            t.visible = false;

        }
    }

    public showGraph(chart: any, table: any) {
        console.log("get data table:");
        console.log("CHART", chart)
        console.log("TABLE",table);
        if (chart.lookupTablePKFieldName !== undefined) {
            var sel = table.selectedItem[chart.lookupTablePKFieldName];
            chart.lookupTablePKValue = this.toDbFormat(sel);
        }

        if (chart.showDateTimePicker !== undefined) {
            console.log("show dtp :" + chart.showDateTimePicker);
            var eDate = new Date();
            var cDate = new Date();
            var bacKdays = chart.showDateTimePicker;
            cDate.setDate(cDate.getDate() - bacKdays);

            Object.assign(chart, { filter: { startDate: cDate, endDate: eDate } });

        }

        this.gvs.getGraphData(chart).subscribe(gd => {
            console.log("get data set:");
            console.log(gd);
            this.gvs.setData(gd, chart.chartType, chart.chartName, chart);

        });

    }

    ngOnInit() {
        var self = this;

        this.loadColumnDescriptions('podatki_elek', 'javna_stavba_mol_agg_v');

        this.tableService.subscribeOnBeginDownloadData()
        .pipe(takeUntil(this.destroy$))
        .subscribe(d => {
            if (d === "table") {
            this.loadingTableId = this.tableShowData?.id ?? null;
            this.proggresBar(true, "Prosimo, počakajte.");
            }
        });


        this.tableService.subscribeOnDoneDownloadData()
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
            this.proggresBar(false, "Done");
            this.loadingTableId = null;
        });

        this.es.subscribeMidChangeEvtListener()
        .pipe(takeUntil(this.destroy$))
        .subscribe(
                f => {

                    self.loaded_ob_mid = f.ob_mid;
                    this.loadDocTypesForObMid(self.loaded_ob_mid);

                    self.closeAllTables();
                    //console.log("changed ob mid table component listener:"+f);
                    self.tables = [];
                    self.tmptables = [];
                    self.editabledatakeys = [];
                },
                e => {
                    console.log(e)
                });


        this.tableService.subscribeDataListener()
        .pipe(takeUntil(this.destroy$))
        .subscribe(data => {
            const idx = this.tables.findIndex(t => t.id === data.id);

            this.santinizeToLocale(data.data, 0, data.data?.length ?? 0);
            data.hasPermissionAdmin = this.ls.isAuthorisedRole("admin");

            let schema = data?.node?.data?.schema || 'app_epa';

            let tableName =
                data?.node?.data?.tablename ||
                data?.node?.data?.tableName ||
                data?.tablename ||
                data?.tableName;

            const geoUrl =
                data?.node?.url ||
                data?.node?.data?.url ||
                data?.node?.data?.additionalData?.url ||
                data?.node?.csvurl;

            const fromGeoServer = this.getSchemaAndTableFromGeoServerUrl(geoUrl);

            if (!tableName && fromGeoServer) {
                schema = fromGeoServer.schema;
                tableName = fromGeoServer.tableName;
            }

            console.log('COLUMN DESC GEO URL:', geoUrl);
            console.log('COLUMN DESC schema:', schema);
            console.log('COLUMN DESC tableName:', tableName);

            if (tableName) {
                this.loadColumnDescriptions(schema, tableName);
            }

            let target: any;

            if (idx === -1) {
                this.tables.push(data);
                target = data;
            } else {
                Object.assign(this.tables[idx], data);
                target = this.tables[idx];
            }

            this.santinizeToLocale(target.data);

            this.ensureColumnDescriptionsLoaded(target);
            this.applyColumnMeta(target);
            this.cdr.detectChanges();
        });


        this.tableService.subscribeTableShowListener()
        .pipe(takeUntil(this.destroy$))
        .subscribe(data => {
            this.tableShowData = data;

            // 1) Ensure we have a canonical object in `tables`
            let tableRef = this.tables.find(t => t.id === data.id);

            if (!tableRef) {
                // show event came before data event → seed tables with this instance
                tableRef = data;
                this.tables.push(tableRef);
            } else {
                // keep the same object instance, just update its fields
                Object.assign(tableRef, data);
            }

            tableRef.visible = data.visible;

            this.santinizeToLocale(tableRef.data);

            this.ensureColumnDescriptionsLoaded(tableRef);

            this.applyColumnMeta(tableRef);

            // 2) Keep tmptables as refs to canonical objects only
            const tmpIdx = this.tmptables.findIndex(t => t.id === tableRef!.id);

            if (data.visible && tmpIdx === -1) {
                this.tmptables.push(tableRef!);
            } else if (!data.visible && tmpIdx > -1) {
                this.tmptables.splice(tmpIdx, 1);
            }

            this.tableService.setCountVisibleTable(this.tmptables.length);

            // 3) select newest visible tab
            const last = this.tmptables.length - 1;
            if (data.visible && last >= 0) {
                this.tabindex = this.tmptables[last].id;

                this.cdr.detectChanges();
                this.focusAndScrollActiveTab();

                } else if (!data.visible) {
                if (!this.tmptables.some(t => t.id === this.tabindex)) {
                    this.tabindex = last >= 0 ? this.tmptables[last].id : null;
                }
            }
        });

        this.tableService.subscribeSelectItemDataListener()
        .pipe(takeUntil(this.destroy$))
        .subscribe(data => {
            for (let t of this.tables) {
                var cdata = t.data;
                for (let f of cdata) {

                    if (f.ftID !== undefined && f.geometry !== undefined && f.geometry.getId() === data.data.getId()) {

                        if (!data.removed)
                            t.selectedItem = f;
                        else
                            t.selectedItem = null;

                        return;
                    }
                }

            }

        });
        this.showRemotePowerDialog = true;

        this.es.getOpenMolDocs()
        .pipe(takeUntil(this.destroy$))
        .subscribe((data: any) => {
            this._documents_folder = data.documentsFolder;
            this.loaded_ob_mid = data.obMid;
            this.currentHouseName = data.houseName || '';

            this.pendingOpenFolderPath = data.folderPath ?? null;
            this.pendingPreviewFileNameLike = data.previewFileNameLike ?? null;

            this.pendingUploadNode = null;
            this.selectedDocNodeKey = null;
            this.selectedDocNode = null;

            this.loadFolderDescriptions();
            this.getFileList(null);
        });
    }

    private findFirstTreeNode(nodes: TreeNode[]): TreeNode | null {
        if (!nodes?.length) return null;
        return nodes[0];
    }

    private findFolderNodeByPath(nodes: TreeNode[], path: string): TreeNode | null {
        for (const node of nodes || []) {
            if (node.data?.type === 'folder' && this.normDir(node.data?.path) === path) {
                return node;
            }
            const found = this.findFolderNodeByPath(node.children || [], path);
            if (found) return found;
        }
        return null;
    }

    public updateSelectedDocTypeFromTree() {
        if (!this.selectedDocNode) {
            this.selectedDocType = '';
            this.selectedDocTypeId = null;
            return;
        }

        if (this.selectedDocNode.data?.type === 'folder') {
            this.selectedDocType = this.selectedDocNode.data?.path || '';
            this.selectedDocTypeId = this.selectedDocNode.data?.id ?? null;
            return;
        }

        const folderPath = this.normDir(this.selectedDocNode.data?.dir);
        const folderNode = this.findFolderNodeByPath(this.docTree, folderPath);

        this.selectedDocType = folderNode?.data?.path || '';
        this.selectedDocTypeId = folderNode?.data?.id ?? null;
    }

    onTreeRowClick(node: TreeNode, event?: MouseEvent) {
        if (!node) return;

        const target = event?.target as HTMLElement | null;

        if (target?.closest('.docTreeActions')) {
            return;
        }

        this.selectedDocNode = node;
        this.selectedDocNodeKey = node.key ?? null;

        this.updateSelectedDocTypeFromTree();
        this.onBeforeUploadFile(null);

        if (node.data?.type === 'folder') {
            node.expanded = !node.expanded;
        }

        this.cdr.detectChanges();
    }

    private expandParentsToNode(
        nodes: TreeNode[],
        key: string
    ): boolean {

        for (const node of nodes || []) {

            if (node.key === key) {
                return true;
            }

            if (node.children?.length) {

                const found = this.expandParentsToNode(
                    node.children,
                    key
                );

                if (found) {
                    node.expanded = true;
                    return true;
                }
            }
        }

        return false;
    }

    private expandNodeAndDescendants(node: TreeNode): void {
        if (!node) return;

        if (node.data?.type === 'folder') {
            node.expanded = true;
        }

        for (const child of node.children || []) {
            this.expandNodeAndDescendants(child);
        }
    }

    private hasFilesInFolder(nodes: TreeNode[], folderPath: string): boolean {
        const folder = this.findFolderNodeByPath(nodes, this.normDir(folderPath));
        if (!folder) return false;

        const walk = (items: TreeNode[]): boolean =>
            (items || []).some(n => n.data?.type === 'file' || walk(n.children || []));

        return walk(folder.children || []);
    }

    private loadDocTypesForObMid(obMid: any, expandedKeys?: Set<string>): void {
        if (!obMid) return;

        this.tableService.getDocumentTypesFromBackend(obMid)
            .pipe(takeUntil(this.destroy$))
            .subscribe((types: any) => {
                const arr = Array.isArray(types) ? types : [];

                this.docTypes = arr;

                const finishTree = (files: any[]) => {
                    this.docTree = this.buildDocumentTree(arr, files);

                    if (this.pendingPreviewFileNameLike) {
                        const normalize = (v: any) =>
                            String(v ?? '')
                                .toLowerCase()
                                .normalize('NFD')
                                .replace(/[\u0300-\u036f]/g, '')
                                .replace(/[_-]+/g, ' ')
                                .replace(/\s+/g, ' ')
                                .trim();

                        const needle = normalize(this.pendingPreviewFileNameLike);

                        const file = files.find((f: any) =>
                            normalize(f.originalName).includes(needle)
                        );

                        if (file) {
                            const fileNode = this.findTreeNodeByKey(this.docTree, `file-${file.docId}`);

                            if (fileNode) {
                                this.selectedDocNode = fileNode;
                                this.selectedDocNodeKey = fileNode.key ?? null;

                                const folderPath = this.normDir(file.dir);
                                const folderNode = this.findFolderNodeByPath(this.docTree, folderPath);

                                if (folderNode?.key) {
                                    this.expandParentsToNode(this.docTree, folderNode.key);
                                    folderNode.expanded = true;
                                }

                                this.openDocumentPreview(fileNode);
                            }
                        } else {
                            this.showMsgs('warn', `Dokument ne obstaja.`);

                            const fallbackFolder = this.findFolderNodeByPath(this.docTree, 'SPLOŠNO');
                            if (fallbackFolder) {
                                this.expandParentsToNode(this.docTree, fallbackFolder.key!);
                                fallbackFolder.expanded = true;
                                this.selectedDocNode = fallbackFolder;
                                this.selectedDocNodeKey = fallbackFolder.key ?? null;
                            }
                        }

                        this.pendingPreviewFileNameLike = null;
                    }

                    if (expandedKeys) {
                        this.restoreExpandedFolderKeys(this.docTree, expandedKeys);
                    }

                    if (this.pendingSelectNodeId) {
                        this.expandPathToNode(this.docTree, this.pendingSelectNodeId);
                        const found = this.findTreeNodeByKey(this.docTree, this.pendingSelectNodeId);
                        this.selectedDocNode = found ?? null;
                        this.selectedDocNodeKey = found?.key ?? null;

                        if (this.selectedDocNode?.data?.type === 'folder') {
                            this.selectedDocNode.expanded = true;
                        }

                        this.pendingSelectNodeId = null;
                    } else {
                        this.selectedDocNode = null;
                        this.selectedDocNodeKey = null;
                    }

                    if (this.pendingOpenFolderPath) {
                        this.setDocumentTreeExpanded(this.docTree, false);
                        const folderPath = this.pendingOpenFolderPath;

                        const node = this.findFolderNodeByPath(this.docTree, folderPath);

                        if (node) {
                            this.expandParentsToNode(this.docTree, node.key!);

                            this.expandNodeAndDescendants(node);

                            this.selectedDocNode = node;
                            this.selectedDocNodeKey = node.key ?? null;

                            this.updateSelectedDocTypeFromTree();

                            const hasFiles = this.hasFilesInFolder(this.docTree, folderPath);

                            if (!hasFiles) {
                                this.showMsgs(
                                    'warn',
                                    `V mapi '${folderPath}' ni dokumenta.`
                                );
                            }
                        } else {
                            this.showMsgs(
                                'warn',
                                `Mapa '${folderPath}' ne obstaja.`
                            );
                        }

                        this.pendingOpenFolderPath = null;
                    }

                    this.updateSelectedDocTypeFromTree();
                    this.cdr.detectChanges();
                };

                if (!this._documents_folder) {
                    finishTree([]);
                    return;
                }

                this.tableService
                    .getData(this.gs.getRestUrl() + "/api/documents/list?id=" + this._documents_folder, true)
                    .pipe(takeUntil(this.destroy$))
                    .subscribe({
                        next: (docs: any) => finishTree(Array.isArray(docs) ? docs : []),
                        error: () => finishTree([])
                    });

            }, () => {
                this.docTree = [];
                this.selectedDocNode = null;
            });
    }


    getGlobalFilterFields(table: any): string[] {
        return (table?.fields || []).map((x: any) => x.field);
    }

    selectedUploadFile: File | null = null;

    uploading = false;
    uploadProgress = 0;

    private async sha256Hex(file: File): Promise<string | null> {
        // WebCrypto je dostopen samo na https in localhost, ne na http
        const subtle = (globalThis as any)?.crypto?.subtle;
        if (!subtle) return null;

        const buf = await file.arrayBuffer();
        const hash = await subtle.digest('SHA-256', buf);
        const bytes = Array.from(new Uint8Array(hash));
        return bytes.map(b => b.toString(16).padStart(2, '0')).join('');
    }

    public onBeforeUploadFile(event: any) {
        if (!this._documents_folder) return;

        this.uploadurl = `${this.gs.getRestUrl()}/api/documents/upload`;
    }

    isSelectedFolder(node: TreeNode): boolean {
        return !!node
            && node.data?.type === 'folder'
            && this.selectedDocNodeKey === node.key;
    }

    openCreateSubfolderFromNode(node: TreeNode) {
        if (!node || node.data?.type !== 'folder') return;

        this.selectedDocNode = node;
        this.selectedDocNodeKey = node.key ?? null;
        this.createUnderSelected = true;
        this.newFolderName = '';
        this.showNewFolderDialog = true;

        this.updateSelectedDocTypeFromTree();
    }

    openRenameFolderDialog(node: TreeNode) {
        if (!node || node.data?.type !== 'folder') return;

        this.selectedDocNode = node;
        this.selectedDocNodeKey = node.key ?? null;
        this.renameFolderNode = node;
        this.renameFolderName = node.label || '';
        this.showRenameFolderDialog = true;
    }

    public onRowSelect(event: any) {
        const layerId = Number(event.data.layerID);

        const layer = this.tables.find(table => table.id == layerId);
        console.log("TABLE", layer)
        this.displayCsvBtns = null;
        this.selectedTabItem  = true;
        console.warn("SELECTED TAB ITEM: ", this.selectedTabItem)
        if(layer.node.data.chartData) this.displayCsvBtns = layer.node.data.chartData;
        // table.node.data.chartData
        // this.remotePowerService.isRemotePowerCalculated$
        this.showRemotePowerDetailsDialog = false;
        // console.warn("EVENT", event, this.tableShowData)
        if(event.data.ftID.toLowerCase().includes('rezultat_potencialni_daljinski_sistemi')){
            this.openRemotePowerAnalyse(event)
        }
        this.tableService.setTableRowSelection(event.data);
        //console.log(event);
    }

    openRemotePowerAnalyse(event: any){
        this.showRemotePowerDetailsDialog = true;
        this.remotePowerDetails = event.data;
    }

    public onRowUnselect(event: any) {
        //console.log("table row unselect !");  
        this.tableService.setTableRowUnSelection(event.data);
    }

    public exportEscapedCSV(dt: any, table: any): void {
        table.data.forEach((row: any) => {
            Object.keys(row).forEach((key: string) => {
            if (typeof row[key] === 'string' || row[key] instanceof String) {
                row[key] = row[key].replace(/;/g, ',');
            } else if (row[key] === null) {
                row[key] = '';
            }
            });
        });

        dt.exportCSV();
    }

    openDetailsTable(event: any){
        this.showRemotePowerDetailsDialog = false;
        this.showRemotePowerDetailsTableDialog = true;
        this.remotePowerDetailsTable = event.response;
        this.remotePowerPayload = event.payload;
        this.showMsgs('info', event.response.msg)
        // console.error("ALLOO", this.remotePowerDetails)
    }

    closePowerDetails(event: any) {
        const open = !!event?.open;

        this.showRemotePowerDetailsTableDialog = open;

        if (typeof event?.openDetails === 'boolean') {
            this.showRemotePowerDetailsDialog = event.openDetails;
        }

        const msg = event?.response?.msg || event?.msg?.detail;
        if (msg) this.showMsgs('info', msg);
    }

    onErrorEmit(event: any): void {
        this.showMsgs('error', event.response.msg)
    }

    showMsgs(severity: string, msg: any) {
        if (!msg) return;
        this.messageService.add({ severity, summary: 'Obvestilo', detail: msg });
    }

    onHideRemotePowerDetailsDialog() {
        this.showRemotePowerDetailsDialog = false;
    }

    onHideRemotePowerDetailsTableDialog() {
        this.showRemotePowerDetailsTableDialog = false;
    }

    private mapToTreeNodes(nodes: any[], parentPath: string = '', level: number = 0): TreeNode[] {
        return (nodes || []).map((node: any) => {
            const currentPath = parentPath ? `${parentPath}/${node.label}` : node.label;

            return {
                key: `folder-${node.id}`,
                label: node.label,
                data: {
                    type: 'folder',
                    id: node.id,
                    path: currentPath,
                    sortNo: node.sortNo ?? 9999
                },
                children: this.mapToTreeNodes(node.children || [], currentPath, level + 1),
                expanded: false
            };
        });
    }

    openCreateFolderDialog(createAsChild: boolean) {
        this.createUnderSelected = createAsChild;
        this.newFolderName = '';
        this.showNewFolderDialog = true;
    }

    createFolder() {
        const label = (this.newFolderName || '').trim();
        if (!label) {
            this.showMsgs('warn', 'Vnesite ime mape.');
            return;
        }

        if (!this.loaded_ob_mid) {
            this.showMsgs('error', 'Manjka ob_mid.');
            return;
        }

        const parentId = this.createUnderSelected
            ? (this.selectedDocNode?.data?.id ?? null)
            : null;

        this.tableService.createDocumentType({
            obMid: this.loaded_ob_mid,
            parentId,
            label
        })
        .pipe(takeUntil(this.destroy$))
        .subscribe({
            next: (res: any) => {
                this.showNewFolderDialog = false;
                this.showMsgs('success', 'Mapa je uspešno ustvarjena.');
                this.pendingSelectNodeId = `folder-${res?.id}`;
                this.loadDocTypesForObMid(this.loaded_ob_mid);
            },
            error: (err) => {
                const msg = err?.error?.error || 'Napaka pri ustvarjanju mape.';
                this.showMsgs('error', msg);
            }
        });
    }

    private findTreeNodeByKey(nodes: TreeNode[], key: string): TreeNode | null {
        for (const node of nodes || []) {
            if (node.key === key) return node;
            const found = this.findTreeNodeByKey(node.children || [], key);
            if (found) return found;
        }
        return null;
    }

    downloadTreeFile(node: TreeNode) {
        if (node?.data?.type !== 'file') return;
        this.tableService.getFile(node.data.url, true, node.data.originalName);
    }

    deleteTreeFile(node: TreeNode) {
        if (node?.data?.type !== 'file') return;

        const selectedKey = this.selectedDocNodeKey;

        this.cs.confirm({
            header: 'Ali želite izbrisati datoteko ?',
            accept: () => {
                this.tableService.deleteFile(node.data.urlDelete, true).subscribe(() => {
                    this.getFileList(selectedKey);
                });
            }
        });
    }

    renameFolder() {
        const label = (this.renameFolderName || '').trim();
        const node = this.renameFolderNode;

        if (!node || node.data?.type !== 'folder') {
            this.showMsgs('warn', 'Izberi veljavno mapo.');
            return;
        }

        if (!label) {
            this.showMsgs('warn', 'Vnesite novo ime mape.');
            return;
        }

        if (!this.loaded_ob_mid) {
            this.showMsgs('error', 'Manjka ob_mid.');
            return;
        }

        this.tableService.renameDocumentType({
            id: Number(node.data.id),
            obMid: Number(this.loaded_ob_mid),
            label
        })
        .pipe(takeUntil(this.destroy$))
        .subscribe({
            next: (res: any) => {
                this.showRenameFolderDialog = false;

                this.renameFolderNode = null;
                this.renameFolderName = '';

                this.showMsgs('success', 'Mapa je uspešno preimenovana.');

                this.pendingSelectNodeId = node.key ?? null;
                this.loadDocTypesForObMid(this.loaded_ob_mid);
            },
            error: (err) => {
                const msg = err?.error?.error || 'Napaka pri preimenovanju mape.';
                this.showMsgs('error', msg);
            }
        });
    }

    expandAllDocumentTree() {
        this.setDocumentTreeExpanded(this.docTree, true);
    }

    collapseAllDocumentTree() {
        this.setDocumentTreeExpanded(this.docTree, false);
    }

    private setDocumentTreeExpanded(nodes: TreeNode[], expanded: boolean) {
        for (const node of nodes || []) {
            if (node.data?.type === 'folder') {
                node.expanded = expanded;
            }

            if (node.children?.length) {
                this.setDocumentTreeExpanded(node.children, expanded);
            }
        }

        this.docTree = [...this.docTree];
    }

    showPreviewDialog = false;
    previewFileName = '';
    previewUrl: string | null = null;
    previewObjectUrl: string | null = null;
    previewDownloadUrl: string | null = null;
    previewSafeUrl: SafeResourceUrl | null = null;
    previewLoading = false;
    previewFullscreen = false;
    previewType: 'pdf' | 'image' | 'text' | 'office' | 'unknown' = 'unknown';

    togglePreviewFullscreen() {
        this.previewFullscreen = !this.previewFullscreen;

        setTimeout(() => {
            this.cdr.detectChanges();
            window.dispatchEvent(new Event('resize'));
        });
    }

    closeDocumentPreview() {
        this.showPreviewDialog = false;
        this.previewFullscreen = false;

        if (this.previewObjectUrl) {
            URL.revokeObjectURL(this.previewObjectUrl);
            this.previewObjectUrl = null;
        }

        this.previewUrl = null;
        this.previewSafeUrl = null;
        this.previewDownloadUrl = null;
        this.previewLoading = false;
    }

    openDocumentPreview(node: TreeNode, event?: MouseEvent) {
        event?.stopPropagation();

        if (node?.data?.type !== 'file') return;

        this.previewFullscreen = false;
        this.previewFileName = node.data.originalName || node.label || 'Dokument';
        this.previewDownloadUrl = node.data.url;
        this.previewUrl = null;
        this.previewSafeUrl = null;
        this.previewLoading = true;

        const name = this.previewFileName.toLowerCase();

        if (name.endsWith('.pdf')) this.previewType = 'pdf';
        else if (/\.(png|jpg|jpeg|gif|webp|bmp|svg)$/.test(name)) this.previewType = 'image';
        else if (/\.(txt|csv|json|xml|log|csv)$/.test(name)) this.previewType = 'text';
        else if (/\.(doc|docx|xls|xlsx|ppt|pptx)$/.test(name)) this.previewType = 'office';
        else this.previewType = 'unknown';

        if (this.previewObjectUrl) {
            URL.revokeObjectURL(this.previewObjectUrl);
            this.previewObjectUrl = null;
        }

        this.showPreviewDialog = true;

        if (this.previewType === 'office' || this.previewType === 'unknown') {
            this.previewLoading = false;
            return;
        }

        this.http.get(node.data.urlPreview, { responseType: 'blob' })
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: blob => {
                    this.previewObjectUrl = URL.createObjectURL(blob);
                    this.previewUrl = this.previewObjectUrl;
                    if (this.previewType === 'pdf') {
                        this.previewSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                            this.previewObjectUrl + '#toolbar=0&navpanes=0&scrollbar=1'
                        );
                    } else {
                        this.previewSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.previewObjectUrl);
                    }
                    this.previewLoading = false;
                },
                error: () => {
                    this.previewLoading = false;
                    this.showMsgs('error', 'Predogleda dokumenta ni bilo mogoče odpreti.');
                }
            });
    }

    private readonly MOL_EOL_FOLDER = 'EOL';
    private readonly MOL_OVE_FOLDER = 'SE';

    private pendingOpenFolderPath: string | null = null;
    private pendingPreviewFileNameLike: string | null = null;

    public isMolProjectColumn(field: string, table: any): boolean {
        return this.isMol()
            && Number(table?.id) === Number(this.gs.getJavneStavbeMolLayerId())
            && (
                field === 'eol_projekt' ||
                field === 'ove_projekt' ||
                field === 'energetske_izkaznice'
            );
    }

    public onMolProjectColumnClick(item: any, table: any, field: string, event?: MouseEvent): void {
        if (!this.isMolProjectColumn(field, table)) return;

        event?.stopPropagation();

        if (!item?._documents_folder) {
            this.showMsgs('warn', 'Manjka mapa dokumentov za izbrano stavbo.');
            return;
        }

        this._documents_folder = item._documents_folder;
        this.currentHouseName = item?.naziv_stavbe || item?.naziv || '';

        this.pendingOpenFolderPath = null;
        this.pendingPreviewFileNameLike = null;

        switch (field) {
            case 'eol_projekt':
                this.pendingOpenFolderPath = this.MOL_EOL_FOLDER;
                break;

            case 'ove_projekt':
                this.pendingOpenFolderPath = this.MOL_OVE_FOLDER;
                break;

            case 'energetske_izkaznice':
                this.pendingPreviewFileNameLike = 'energetska izkaznica';
                break;
        }

        this.pendingUploadNode = null;
        this.selectedDocNodeKey = null;
        this.selectedDocNode = null;

        this.getFileList(null);
    }

    public razbijIzkaznice(item: any): any[] {
        return String(item?.energetske_izkaznice ?? '')
            .split(';')
            .map((s: string) => s.trim())
            .filter((s: string) => s.length > 0)
            .map((s: string) => ({
                besedilo: s,
                stevilka: (s.match(/^([0-9]+-[0-9]+-[0-9]+-[0-9]+)/) || [])[1] || null
            }));
    }

    public odpriIzkaznico(item: any, stevilka: string | null, event?: MouseEvent): void {
        event?.stopPropagation();

        if (!stevilka) return;

        if (!item?._documents_folder) {
            this.showMsgs('warn', 'Manjka mapa dokumentov za izbrano stavbo.');
            return;
        }

        this._documents_folder = item._documents_folder;
        this.currentHouseName = item?.naziv_stavbe || item?.naziv || '';

        this.pendingOpenFolderPath = null;
        this.pendingPreviewFileNameLike = stevilka;

        this.pendingUploadNode = null;
        this.selectedDocNodeKey = null;
        this.selectedDocNode = null;

        this.getFileList(null);
    }


    private getColumnDescriptionKey(schema: string, tableName: string): string {
        return `${schema}.${tableName}`;
    }

    private loadColumnDescriptions(schema: string, tableName: string): void {
        const key = this.getColumnDescriptionKey(schema, tableName);

        if (this.columnDescriptions[key] || this.columnDescriptionsLoading[key]) {
            return;
        }

        this.columnDescriptionsLoading[key] = true;

        const url =
            `${this.gs.getRestUrl()}/api/tablecolumndescription/` +
            `${encodeURIComponent(schema)}/` +
            `${encodeURIComponent(tableName)}`;

        this.tableService.getData(url, true)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (res: any) => {
                    const rows = Array.isArray(res)
                        ? res
                        : res?.tableColumnDescription || [];

                    const map: Record<string, any> = {};

                    rows.forEach((r: any) => {
                        const columnName = r.columnName || r.column_name;

                        if (columnName) {
                            map[columnName] = {
                                label: r.label || null,
                                groupName: r.groupName || null,
                                description: r.description || r.opis || '',
                                priority: Number(r.priority ?? 9999),
                                headerColor: r.headerColor || r.header_color || null,
                                cellColor: r.cellColor || r.cell_color || null,
                                visible: r.visible === undefined ? true : r.visible !== false
                            };
                            if (r.label) {
                                this.columnLabels[columnName] = r.label;
                                this.tableService.setColumnLabel(columnName, r.label);
                            }
                        }
                    });
                    console.log('COLUMN LABELS:', this.columnLabels);

                    this.columnDescriptions[key] = map;
                    this.columnDescriptionsLoading[key] = false;

                    this.tmptables.forEach(t => this.applyColumnMeta(t));

                    this.cdr.detectChanges();
                },
                error: () => {
                    this.columnDescriptions[key] = {};
                    this.columnDescriptionsLoading[key] = false;
                }
            });
    }

    getColumnHoverText(col: any, table: any): string {
        return this.getColumnMeta(col.field, table)?.description || '';
    }

    private getSchemaAndTableFromGeoServerUrl(url: string): { schema: string, tableName: string } | null {
        if (!url) return null;

        const decoded = decodeURIComponent(url);

        const match = decoded.match(/typeName=([^&]+)/) || decoded.match(/typename=([^&]+)/);
        if (!match) return null;

        let typeName = match[1];

        if (typeName.includes(':')) {
            const parts = typeName.split(':');
            return { schema: parts[0], tableName: parts[1] };
        }

        if (typeName.includes('.')) {
            const parts = typeName.split('.');
            return { schema: parts[0], tableName: parts[1] };
        }

        return { schema: 'app_epa', tableName: typeName };
    }

    private resolveColumnDescriptionTarget(table: any): { schema: string, tableName: string } | null {
        let schema = table?.node?.data?.schema || 'app_epa';

        let tableName =
            table?.node?.data?.tablename ||
            table?.node?.data?.tableName ||
            table?.tablename ||
            table?.tableName;

        const geoUrl =
            table?.node?.url ||
            table?.node?.data?.url ||
            table?.node?.data?.additionalData?.url ||
            table?.node?.csvurl ||
            table?.node?.data?.csvurl;

        const fromGeoServer = this.getSchemaAndTableFromGeoServerUrl(geoUrl);

        if (!tableName && fromGeoServer) {
            schema = fromGeoServer.schema;
            tableName = fromGeoServer.tableName;
        }

        return tableName ? { schema, tableName } : null;
    }

    private ensureColumnDescriptionsLoaded(table: any): void {
        const target = this.resolveColumnDescriptionTarget(table);
        if (!target) return;

        const key = this.getColumnDescriptionKey(target.schema, target.tableName);

        if (this.columnDescriptions[key]) {
            this.applyColumnMeta(table);
            return;
        }

        this.loadColumnDescriptions(target.schema, target.tableName);
    }

    private getColumnMetaKey(table: any): string {
        const schema = table?.node?.data?.schemaname || table?.node?.data?.schema || 'podatki_elek';
        const tableName = table?.node?.data?.tablename || table?.node?.data?.table_name;

        return `${schema}.${tableName}`;
    }

    getColumnMeta(colField: string, table: any): any {
        const schema = 'podatki_elek';
        const tableName = 'javna_stavba_mol_agg_v';
        const key = this.getColumnDescriptionKey(schema, tableName);

        return this.columnDescriptions?.[key]?.[colField] || null;
    }

    getColumnStyle(colField: string, table: any, part: 'header' | 'cell') {
        const meta = this.getColumnMeta(colField, table);

        return {
            'background-color': part === 'header'
            ? meta?.headerColor
            : meta?.cellColor
        };
    }

    applyColumnMeta(table: any) {
        table.fields = [...table.fields]
            .filter(col => this.getColumnMeta(col.field, table)?.visible !== false)
            .sort((a, b) => {
            const pa = this.getColumnMeta(a.field, table)?.priority ?? 9999;
            const pb = this.getColumnMeta(b.field, table)?.priority ?? 9999;
            return pa - pb;
            });
    }

    getColumnHeaderColor(colField: string, table: any): string | null {
        const meta = this.getColumnMeta(colField, table);
        return meta?.headerColor || null;
    }

    public getIconColumnCount(table: any): number {
        let n = 0;
        if (table?.node?.data?.tablebutton !== undefined && this.canopenFileDialog) n++;
        if (this.canEditTable(table)) n++;
        if (table?.iSadditionalData && table?.hasPermissionAdmin) n++;
        return n;
    }

    private buildHeaderLayout(table: any): { top: any[], bottom: any[] } {
        const cols = (table?.fields || []).filter((c: any) => !c.hidden);

        const top: any[] = [];
        const bottom: any[] = [];

        for (const col of cols) {
            const meta = this.getColumnMeta(col.field, table);
            const name = meta?.groupName || '';

            if (!name) {
                top.push({ kind: 'col', col, span: 1 });
                continue;
            }

            const last = top[top.length - 1];

            if (last && last.kind === 'group' && last.name === name) {
                last.span++;
                if (!last.color) {
                    last.color = meta?.headerColor || null;
                }
            } else {
                top.push({
                    kind: 'group',
                    name,
                    color: meta?.headerColor || null,
                    span: 1
                });
            }

            bottom.push({ col });
        }

        return { top, bottom };
    }

    public getHeaderTopRow(table: any): any[] {
        return this.buildHeaderLayout(table).top;
    }

    public getHeaderBottomRow(table: any): any[] {
        return this.buildHeaderLayout(table).bottom;
    }

    private loadFolderDescriptions(): void {
        console.log('LOAD FOLDER DESCRIPTIONS');
        const url = `${this.gs.getRestUrl()}/api/tablecolumndescription/${this.DOC_FOLDER_DESC_SCHEMA}/${this.DOC_FOLDER_DESC_TABLE}`;

        this.tableService.getData(url, true)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
            next: (res: any) => {
                console.log('FOLDER DESC RAW:', res);

                const rows = Array.isArray(res)
                ? res
                : Array.isArray(res?.tableColumnDescription)
                    ? res.tableColumnDescription
                    : [];

                const map: Record<string, string> = {};

                rows.forEach((r: any) => {
                const name = this.normDir(
                    r.columnName ||
                    r.column_name ||
                    r.columnname
                );

                const opis =
                    r.description ||
                    r.opis ||
                    r.Description ||
                    '';

                if (name && opis) {
                    map[name] = opis;
                }
                });

                console.log('FOLDER DESC MAP:', map);

                this.folderDescriptions = map;
                this.folderDescriptionsLoaded = true;

                this.applyFolderDescriptionsToTree(this.docTree);

                console.log('DOC TREE WITH DESCRIPTIONS:', this.docTree);

                this.cdr.detectChanges();
            },
            error: (err) => {
                console.error('FOLDER DESC ERROR:', err);
                this.folderDescriptions = {};
                this.folderDescriptionsLoaded = true;
            }
            });
    }

    private applyFolderDescriptionsToTree(nodes: TreeNode[]): void {
        for (const node of nodes || []) {
            if (node.data?.type === 'folder') {
            const path = this.normDir(node.data?.path);
            const label = this.normDir(node.label);

            node.data.description =
                this.folderDescriptions[path] ||
                this.folderDescriptions[label] ||
                '';
            }

            this.applyFolderDescriptionsToTree(node.children || []);
        }
    }

    getDocFolderHoverText(node: TreeNode): string {
        return node.data?.description || String(node.label ?? '');
    }
    
}
